"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderContentLocation = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const graphql_1 = require("../graphql");
const VehicleTypePriceFee_1 = require("./VehicleTypePriceFee");
let OrderContentLocation = class OrderContentLocation {
    constructor() {
        this.duration = 60;
        this.order = 0;
        this.waitingPrice = 0;
        this.waitingFee = 0;
        this.entrancePrice = 0;
        this.entranceFee = 0;
        this.parkingPrice = 0;
        this.parkingFee = 0;
        this.tollPrice = 0;
        this.tollFee = 0;
        this.additionalPrice = 0;
        this.additionalFee = 0;
        this.vehicleTypesPricesFees = [];
    }
};
exports.OrderContentLocation = OrderContentLocation;
__decorate([
    (0, graphql_1.GField)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OrderContentLocation.prototype, "locationId", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GInt),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderContentLocation.prototype, "duration", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GInt),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderContentLocation.prototype, "order", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GFloat),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderContentLocation.prototype, "waitingPrice", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GFloat),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderContentLocation.prototype, "waitingFee", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GFloat),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderContentLocation.prototype, "entrancePrice", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GFloat),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderContentLocation.prototype, "entranceFee", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GFloat),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderContentLocation.prototype, "parkingPrice", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GFloat),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderContentLocation.prototype, "parkingFee", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GFloat),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderContentLocation.prototype, "tollPrice", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GFloat),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderContentLocation.prototype, "tollFee", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GFloat),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderContentLocation.prototype, "additionalPrice", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GFloat),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderContentLocation.prototype, "additionalFee", void 0);
__decorate([
    (0, graphql_1.GField)(() => [VehicleTypePriceFee_1.VehicleTypePriceFee]),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => VehicleTypePriceFee_1.VehicleTypePriceFee),
    __metadata("design:type", Array)
], OrderContentLocation.prototype, "vehicleTypesPricesFees", void 0);
exports.OrderContentLocation = OrderContentLocation = __decorate([
    (0, graphql_1.GObjectType)("OrderContentLocation"),
    (0, graphql_1.GInputType)("OrderContentLocationInput"),
    (0, class_transformer_1.Exclude)()
], OrderContentLocation);
//# sourceMappingURL=OrderContentLocation.js.map